import React, { useRef, useState } from "react";
import axios from "../../../utils/axios";
import { useParams } from "react-router-dom";

const FileUploadButton: React.FC<any> = ({
  id = "file_upload",
  text = "Upload",
  fileType = "imbeded_image",
  onComplete = () => {},
}) => {
  const fileInput = useRef(null);
  const params = useParams();
  const [loading, setLoading] = useState(false);

  const saveImage = async (event: any) => {
    const images = event.target.files;

    if (!images[0]) return;
    setLoading(true);

    let formData = new FormData();
    formData.append("file", images[0]);
    formData.append("siteId", params!.siteId as string);

    try {
      const config = {
        headers: { "content-type": "multipart/form-data" },
        onUploadProgress: (event: any) => {
          if (process.env.NODE_ENV === "development") {
            console.log(
              `Current progress:`,
              Math.round((event.loaded * 100) / event.total)
            );
          }
        },
      };

      const {
        data: { path },
      }: any = await axios.post("files", formData, config);

      onComplete(path);
    } catch (error) {
      console.log(error);
    }

    setLoading(false);
  };

  return (
    <>
      <button
        type="button"
        // @ts-ignore
        onClick={() => fileInput?.current?.click()}
        disabled={loading}
        className="bg-green-700 py-2 px-4 text-white text-xs font-medium rounded-full hover:bg-green-900 cursor-pointer"
      >
        {loading ? "Loading ..." : text}
      </button>

      <input
        id={id}
        type="file"
        name="file"
        hidden
        ref={fileInput}
        accept="image/*"
        onChange={saveImage}
      />
    </>
  );
};

export default FileUploadButton;
